/**
 * Decode the payload of a JWT WITHOUT verifying the signature.
 *
 * Use only when you need to read claims for UI purposes (e.g. extracting
 * impersonation context, checking expiration before sending a request).
 * NEVER trust the result for authorization — the backend validates the
 * signature on every request.
 */
export function decodeJwt<T = Record<string, unknown>>(token: string): T | null {
  if (typeof token !== 'string' || token.length === 0) return null
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const payload = parts[1]
    // base64url → base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const json = atob(padded)
    // Handle UTF-8 — Django can emit non-ASCII names
    const decoded = decodeURIComponent(
      Array.prototype.map
        .call(json, (c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(decoded) as T
  } catch {
    return null
  }
}
